<template>
    <div>
        <Balance />
        <List />
    </div>
</template>
<script setup>
import Balance from "@/components/crypto/binance/positions/Balance"
import List from "@/components/crypto/binance/positions/List"
</script>
